import routes from 'actions/routes';
import { generateReadActionCreator, generateCreateActionCreator } from 'actions/crudActionCreators';
import ACTION_NAMES from 'actions/ACTION_NAMES';

export default {
    readCustomFieldsParentGroups: generateReadActionCreator(routes.API_CUSTOM_FIELDS_PARENT_GROUPS, ACTION_NAMES.CUSTOM_FIELDS_PARENT_GROUPS),
    addCustomFieldGroup: generateCreateActionCreator(routes.API_CUSTOM_FIELDS_GROUPS, ACTION_NAMES.CUSTOM_FIELDS_GROUPS)
};
